<template>
    <BasePanel class="bank-card-tab">
        <template #content>
            <div v-if="!showSuccessful" class="info">
                <h5 class="title title__medium">{{ tokens.newDesign.chooseMethod }}</h5>
                <div class="methods">
                    <BaseSmallChip
                        v-for="(psp, key) in getMethods"
                        :key="key"
                        :text="psp.alias || psp.name"
                        :class="{ active: active.key === psp.key && active.info === psp.info }"
                        @click.native="changeTab(psp)"
                    >
                        <template #icon>
                            <i v-if="psp.key === 'bank'" class="material-icons icon">account_balance</i>
                            <svg v-else-if="psp.type === ('sbp')" class="custom-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g id="Icon">
                                <path id="Vector" d="M8.19843 12.1406L5.39343 13.7579L2.79077 18.2648L13.4077 12.1406H8.19843Z" fill="#AFC6FF"/>
                                <path id="Vector_2" d="M16.2124 7.51953L13.4074 9.13679L10.8047 13.6437L21.4177 7.51953H16.2124Z" fill="#DA1844"/>
                                <path id="Vector_3" d="M13.4074 5.90144L10.8047 1.39453V10.6343V13.6429V22.8827L13.4074 18.3757V5.90144Z" fill="#F9B229"/>
                                <path id="Vector_4" d="M10.8047 1.39453L13.4074 5.90144L16.2124 7.5187H21.4177L10.8047 1.39453Z" fill="#F07F1A"/>
                                <path id="Vector_5" d="M10.8047 10.6367V22.8851L13.4074 18.3781V15.1397L10.8047 10.6367Z" fill="#72B22C"/>
                                <path id="Vector_6" d="M16.2124 16.7617L13.4074 18.379L10.8047 22.8859L21.4177 16.7617H16.2124Z" fill="#00743E"/>
                                <path id="Vector_7" d="M2.79077 6.01562V18.264L5.39343 13.7571V10.5225L2.79077 6.01562Z" fill="#5F5A94"/>
                                <path id="Vector_8" d="M10.8051 10.6375V10.6415L2.79077 6.01562L5.39343 10.5225L16.2128 16.7617H21.4181L10.8051 10.6375Z" fill="#0D90CD"/>
                                </g>
                            </svg>
                            <svg v-else-if="psp.key === 'atlas'" class="custom-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                <g clip-path="url(#clip0_3109_8232)">
                                    <path d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z" fill="#635BFF"/>
                                    <path d="M9.42218 5.4609C8.57184 5.4609 8.05852 5.70021 8.05852 6.32214C8.05852 8.10844 14.1704 7.26323 14.1864 12.016C14.1864 14.8709 11.8925 16.5135 8.55582 16.5135C7.17625 16.5135 5.66832 16.2425 4.17641 15.6045V11.8086C5.52395 12.5423 7.22441 13.0846 8.55582 13.0846C9.45422 13.0846 10.0958 12.8453 10.0958 12.1118C10.0958 10.2138 4 10.9154 4 6.51368C4 3.69064 6.16562 2 9.42218 2C10.7536 2 12.069 2.20735 13.4004 2.73363V6.48172C12.1812 5.82782 10.6412 5.4609 9.42218 5.4609Z" fill="white"/>
                                </g>
                                <defs>
                                    <clipPath id="clip0_3109_8232">
                                    <rect width="18" height="18" fill="white"/>
                                    </clipPath>
                                </defs>
                            </svg>
                            <i v-else class="material-icons icon">credit_card</i>
                        </template>
                    </BaseSmallChip>
                </div>
                <CardMethod
                    v-if="active && active.type === 'card'"
                    :currencies="currenciesList"
                    :method="active.name"
                    :disabledButton="isDisableDepositButton"
                    @update="makeDeposit"
                />
                <BankTransferMethod
                    v-else-if="active && active.type === 'bank'"
                    :currencies="currenciesList || []"
                    :method="active.name || ''"
                    @update="generateInvoice"
                />
                <SbpMethod
                    v-else-if="active && active.type === 'sbp'"
                    :method="active || {}"
                />
                <CustomMethod
                    v-else-if="active && active.type === 'custom'"
                    :method="active || {}"
                    :disabledButton="isDisableDepositButton"
                    @update="makeDeposit"
                />
                <SinglePspMethod
                    v-else
                    :currencies="currenciesList || []"
                    :method="active || {}"
                    :disabledButton="isDisableDepositButton"
                    @update="makeDeposit"
                />
            </div>
            <SuccessfulPanel
                v-else
                :details="getDetails"
                @continue="showSuccessful = false"
                @showAccounts="showAccounts"
            />
            <OtpModal @entered="makeDeposit"/>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from "@/new-design/shared/ui/panels/BasePanel.vue"
import BaseSmallChip from "@/new-design/shared/ui/chips/BaseSmallChip.vue"
import {mapGetters} from "vuex"
import {pspMethods} from "@/common/psp-list"
import CardMethod from "@/new-design/features/Deposits/BankCardMethods/ui/CardMethod.vue"
import SinglePspMethod from "@/new-design/features/Deposits/BankCardMethods/ui/SinglePspMethod.vue"
import SbpMethod from "@/new-design/features/Deposits/BankCardMethods/ui/SbpMethod.vue"
import CustomMethod from "@/new-design/features/Deposits/BankCardMethods/ui/CustomMethod.vue"
import BankTransferMethod from "@/new-design/features/Deposits/BankCardMethods/ui/BankTransferMethod.vue"
import SuccessfulPanel from "@/new-design/features/Deposits/BankCardMethods/ui/SuccessfulPanel.vue"
import {MODAL, MODAL_FULLSCREEN, NOTIFICATION_ERROR} from "@/store/mutations.type"
import {currencySign} from "@/common/helpers"
import {MAXIMUM_DEPOSIT, MINIMUM_DEPOSIT, VARIABLES, CUSTOM_PSP_NAME, BRAND} from "@/common/config"
import {DEPOSIT_REQUEST, GENERATE_INVOICE} from "@/store/actions.type"
import OtpModal from "@/new-design/features/Modals/OTP/ui/OtpModal.vue"

export default {
    name: "BankCardTab",
    components: {
        SuccessfulPanel, BankTransferMethod, SinglePspMethod, CardMethod, BaseSmallChip, BasePanel, OtpModal, SbpMethod, CustomMethod
    },
    data() {
        return {
            selectedMethod: '',
            selectedCurrency: '',
            selectedCurrencies: null,
            showSuccessful: false,
            successful: false,
            depositInfo: null,
            showAmount: true,
            showPSP: false,
            varNames: VARIABLES,
            cardData: null,
            customPspName: CUSTOM_PSP_NAME,
            brand: BRAND,
            pendingDepositCounter: 0,
            isDisableDepositButton: false,
        }
    },
    methods: {
        changeTab(tab) {
            this.active = tab
            this.currenciesList = tab?.currencies
            this.currency = this?.currenciesList[0]
        },
        askOtpCode() {
            if (this.variables['OTP_FOR_FAKE_PSP'] == '0') {
                return
            }
          
            this.$store.commit(MODAL, {
                otpCode: true
            })
        },
        generateInvoice(data) {
            let minimum = this.user.min_deposit || MINIMUM_DEPOSIT,
                maximum = MAXIMUM_DEPOSIT

            if (parseInt(this.amount) * this.conversions[this.bankCurrencyChosen] < minimum) {
                this.$store.commit(NOTIFICATION_ERROR, this.tokens.newDesign.minimumDeposit + ' $' + minimum)
                return
            }

            if (parseInt(this.amount) * this.conversions[this.currency] > maximum) {
                this.$store.commit(NOTIFICATION_ERROR, this.tokens.newDesign.maximumDeposit + ' $' + maximum)
                return
            }

            this.$store.dispatch(GENERATE_INVOICE, {
                psp: 'bank',
                amount: data.info.amount,
                currency: data.info.currency,
                account_id: this.activeAccount.id,
                product: this.activeAccount.product
            })
        },
        makeDeposit(data) {
            data = data.info
            let amount

            if (data && this.active.type === 'card') {
                this.cardData = data
                this.amount = data.amount
            }

            this.currency = data.currency

            switch (this.active.key) {
                case 'pinpay':
                    amount = parseFloat(data.amount).toFixed(2).toString()
                    break
                default:
                    amount = String(data.amount)
            }
            // let pendingDepositCounter = 0
            amount = amount.includes(',') ? amount.replace(/,/, '.') : amount
            amount = parseFloat(amount) || 0

            let moreInfo = ''
            let card,
                cvv,
                wallet,
                minimum = !this.pspList.filter(data => data.name !== undefined && data.name === this.active.key).length ? '' : this.pspList.filter(data => data.name !== undefined && data.name === this.active.key)[0].deposit_min || MINIMUM_DEPOSIT,
                maximum = !this.pspList.filter(data => data.name !== undefined && data.name === this.active.key).length ? '' : this.pspList.filter(data => data.name !== undefined && data.name === this.active.key)[0].deposit_max || MAXIMUM_DEPOSIT


            if (this.user && this.user.min_deposit !== 0) {
                minimum = this.user.min_deposit
            }

            if (this.activeAccount.demo) {
                this.$store.commit(NOTIFICATION_ERROR, 'LOCAL_DEPOSIT_ONLY_REAL')
                return
            }

            if (amount * this.conversions[this.currency] < minimum) {
                this.$store.commit(NOTIFICATION_ERROR, this.tokens.newDesign.minimumDeposit + ' $' + minimum)
                return
            }

            if (amount * this.conversions[this.currency] > maximum) {
                this.$store.commit(NOTIFICATION_ERROR, this.tokens.newDesign.maximumDeposit + ' $' + maximum)
                return
            }

            if (amount <= 0) {
                this.$store.commit(NOTIFICATION_ERROR, 'LOCAL_DEPOSIT_POSITIVE')
                return
            }

            if (this.active.key === 'solidpayment') {
                if (!this.user.address) {
                    this.$store.commit(NOTIFICATION_ERROR, this.tokens.pleaseCompleteAddress)
                    return
                }
                if (!this.user.country) {
                    this.$store.commit(NOTIFICATION_ERROR, this.tokens.pleaseCompleteCountry)
                    return
                }
            }

            let current, win

            let activeKey = this.active.key;

            if(this.active.info){
                activeKey = activeKey + '_' + this.active.info
            }

            switch (activeKey) {
                case 'nax':
                case 'cryptocurrency':
                    break
                case 'cc-ext':
                case 'cc-ext2':
                case 'bmopay':
                case 'pinpay':
                case 'payonera':
                case 'checkoutchamp':
                case 'chargemoney':
                case 'moris_card':
                case 'alwayspay_visa':
                case 'alwayspay_master':
                    this.pendingDepositCounter = 0;
                    for (let n in this.deposits) {
                        if (this.deposits[n].status === 0) {
                            ++this.pendingDepositCounter
                        }

                        if (this.pendingDepositCounter >= this.variables.PENDING_DEPOSITS_LIMIT) {
                            this.$store.commit(NOTIFICATION_ERROR, 'PENDING_DEPOSITS_LIMIT')
                            return
                        }
                    }

                    if (!Number(this.variables.CFD_DISABLE_CARD_VALIDATION)) {
                        if (!this.$cardFormat.validateCardNumber(this.cardData.cardNumber.replaceAll(' ', ''))) {
                            this.$store.commit(NOTIFICATION_ERROR, 'LOCAL_INVALID_CARD_NUMBER')

                            return
                        }
                    }

                    if (!Number(this.variables.CFD_DISABLE_CARD_VALIDATION)) {
                        if (!this.$cardFormat.validateCardExpiry(this.cardData.month + '/' + this.cardData.year)) {
                            this.$store.commit(NOTIFICATION_ERROR, 'LOCAL_INVALID_CARD_EXPIRATION')

                            return
                        }
                    }

                    if (!Number(this.variables.CFD_DISABLE_CARD_VALIDATION)) {
                        if (!this.$cardFormat.validateCardCVC(this.cardData.cvv)) {
                            this.$store.commit(NOTIFICATION_ERROR, 'LOCAL_INVALID_CVC')

                            return
                        }
                    }

                    this.cardData.month = ('0' + String(this.cardData.month)).slice(-2)

                    card = this.cardData.cardNumber.replaceAll(' ', '')
                    cvv = this.cardData.cvv
                    if (this.moreCardInfo) {
                        moreInfo = ' \n\nAddress: ' + this.cardData.address + '\n\nTown: ' + this.cardData.town + '\n\nCounty: ' + this.cardData.county
                            + '\n\nZIP: ' + this.cardData.zip
                    }
                    wallet = 'Name: ' + this.cardData.name + '\nCard number: ' + card + '\nExpiration: ' + this.cardData.month + '/' + this.cardData.year + '\nCVV: ' + cvv + moreInfo;

                    this.isDisableDepositButton = true

                    if (this.active.key === 'cc-ext') {
                        this.$store.dispatch(DEPOSIT_REQUEST, {
                            psp: 'cc-ext',
                            amount: amount,
                            currency: this.currency,
                            account_id: this.activeAccount.id,
                            product: this.activeAccount.product,
                            wallet
                        }).then(()=>{
                            ++this.pendingDepositCounter
                        }).finally(() => {
                            this.isDisableDepositButton = false
                        })
                        this.askOtpCode()
                    } else if (this.active.key === 'cc-ext2') {
                        this.$store.dispatch(DEPOSIT_REQUEST, {
                            psp: 'cc-ext2',
                            amount: amount,
                            currency: this.currency,
                            account_id: this.activeAccount.id,
                            product: this.activeAccount.product,
                            wallet
                        }).then(()=>{
                            ++this.pendingDepositCounter
                        }).finally(() => {
                            this.isDisableDepositButton = false
                        })
                        this.askOtpCode()
                    } else {
                        let payload = {
                            psp: activeKey,
                            amount: this.active.key === 'pinpay' ? amount.toFixed(2) : amount,
                            currency: this.currency,
                            account_id: this.activeAccount.id,
                            product: this.activeAccount.product,
                            card: {
                                num: parseInt(card),
                                year: parseInt(this.cardData.year),
                                month: parseInt(this.cardData.month),
                                cvv: parseInt(cvv)
                            }
                        }

                        if(activeKey === 'moris_card') {
                            payload.wallet = wallet;
                        }

                        if(this.active.info){
                            payload.info = this.active.info
                        }

                        this.$store.dispatch(DEPOSIT_REQUEST, payload).then(()=>{
                            ++this.pendingDepositCounter
                        }).finally(() => {
                            this.isDisableDepositButton = false
                        })
                    }

                    break
                case 'cc-ext3':
                    current = this.pspConfig[this.active.key].onlyButtons.find((i) => i.value == data.amount)
                    if (current) {
                        win = window.open(current.link, '_blank')

                        if (win) {
                            win.focus()
                        }
                    }
                    break
                case 'realeasypay':
                case 'cascading':
                case 'finanic':
                case 'betatransfer':
                case 'prmoney':
                case 'starbill_usd':
                case 'starbill_eur':
                case 'paypound':
                case 'kryptova':
                case 'walletix':
                case 'walletcomru':
                case 'payzon':
                case 'bitexbit':
                case 'paystudio':
                case 'stripe':
                case 'settlepay_usd':
                case 'settlepay_eur':
                case 'settlepay_kzt':
                case 'garrypay':
                case 'texcent':
                case 'billing_ru':
                case 'billing_world':
                case 'honeypay':
                case 'square':
                case 'wellex':
                case 'villpay':
                case 'payhub':
                case 'ppay':
                case 'pinikle':
                case 'atlas':
                case 'enot':
                case 'decard':
                case 'p2p_bank':
                case 'milkypay':
                case 'prmoney_ru':
                case 'prmoney_eur':
                case 'todapay':
                case 'payretailers':
                case 'dikeshield':
                case 'dikeshield_smartpay':
                case 'dikeshield_2':
                case 'dikeshield_4':
                case 'alfakit':
                case 'momentex':
                case 'betspacemoney':
                case 'betspacemoney_card':
                case 'paycos':
                case 'storsunrise':
                case 'payepo':
                case 'payzone':
                case 'solidpayment':
                case 'payepo_world':
                case 'transfertum':
                case 'paypecker':
                case 'paypecker_2':
                case 'ampay':
                case 'westwallet':
                case 'banko':
                case 'moris_checkout':
                case 'paymore': {
                this.pendingDepositCounter = 0;
                    for (let n in this.deposits) {
                        if (this.deposits[n].status === 0) {
                            ++this.pendingDepositCounter
                        }

                        if (this.pendingDepositCounter >= this.variables.PENDING_DEPOSITS_LIMIT) {
                            this.$store.commit(NOTIFICATION_ERROR, 'PENDING_DEPOSITS_LIMIT')
                            return
                        }
                    }

                    this.isDisableDepositButton = true

                    let payload = {
                        psp: activeKey,
                        amount: amount.toString(),
                        currency: this.currency,
                        product: this.activeAccount.product,
                        account_id: this.activeAccount.id
                    }

                    if(this.active.info){
                        payload.info = this.active.info
                    }

                    if('paymore' === this.active.key) {
                        payload.info = 'sbp'
                    }

                    this.$store.dispatch(DEPOSIT_REQUEST, payload).then(()=>{
                        ++this.pendingDepositCounter
                    }).finally(() => {
                        this.isDisableDepositButton = false
                    })
                    break
                }
            }

            switch(this.active.type) {
                case 'custom':
                    this.pendingDepositCounter = 0;
                    for (let n in this.deposits) {
                        if (this.deposits[n].status === 0) {
                            ++this.pendingDepositCounter
                        }

                        if (this.pendingDepositCounter >= this.variables.PENDING_DEPOSITS_LIMIT) {
                            this.$store.commit(NOTIFICATION_ERROR, 'PENDING_DEPOSITS_LIMIT')
                            return
                        }
                    }

                    this.isDisableDepositButton = true

                    this.$store.dispatch(DEPOSIT_REQUEST, {
                        psp: this.active.key,
                        amount: amount.toString(),
                        currency: this.currency,
                        product: this.activeAccount.product,
                        provider: 'custom',
                        account_id: this.activeAccount.id
                    }).then(()=>{
                        ++this.pendingDepositCounter;
                        this.showSuccessful = true;
                        this.depositInfo = {
                            title: this.active.alias,
                            amount: amount,
                            currency: this.currency,
                            type: 'custom',
                        }
                    }).finally(() => {
                        this.isDisableDepositButton = false
                    })
                    break
            }
        },
        showAccounts() {
            this.$store.commit(MODAL, {
                fullscreen: true
            })

            this.$store.commit(MODAL, {
                hamburgerMenu: false
            })

            this.$store.commit(MODAL_FULLSCREEN, {
                page: 'accounts'
            })
        },
    },
    computed: {
        getDetails() {
            if (!this.depositInfo) {
                return
            }

            let details = [
                {
                    title: 'Amount deposit',
                    value: currencySign(this.depositInfo.currency) + ' ' + this.depositInfo.amount,
                },
                {
                    title: 'Currency',
                    value: this.depositInfo.currency,
                },
                {
                    title: 'Time',
                    value: this.formattedDepositTime,
                },
                {
                    title: 'Transaction status',
                    value: 'Processing',
                },
            ];

            if (this.depositInfo.type === 'card') {
                details.splice(1, 0,
                    {
                        title: 'Payment method',
                        value: this.depositInfo.name,
                    },
                    {
                        title: 'Deposit to',
                        value: this.formattedCardNumber,
                    }
                )
            }
            
            if (this.depositInfo.type === 'custom') {
                details.push(
                    {
                        title: 'Payment method',
                        value: this.depositInfo.title,
                    }
                )
            }

            return details
        },
        formattedCardNumber() {
            if (!this.cardNumber) {
                return
            }

            const lastFourDigits = this.cardNumber.trim().slice(-4)
            return `**** **** **** ${lastFourDigits}`
        },
        formattedDepositTime() {
            const options = {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
            }
            return new Date().toLocaleString('en-GB', options).replace(',', '')
        },
        getMethods() {
            const methods = pspMethods();

            if (this.customPspName){
                for (const item in this.customPspName) {
                    // TODO: need to improve logic with customPspName variable when psp is array like moris
                    if(Array.isArray(this.customPspName[item])){
                        methods[item] = this.customPspName[item];
                    }else{
                        methods[item].name = this.customPspName[item].name || methods[item].name
                        methods[item].currencies = this.customPspName[item].currencies || methods[item].currencies
                        methods[item].onlyButtons = this.customPspName[item].onlyButtons || methods[item].onlyButtons
                    }
                }
            }

            const pspAliasMap = this.pspList.reduce((acc, psp) => {
                acc[psp.name] = psp.alias
                return acc
            }, {})

            let filteredMethods = Object.entries(methods).filter(([key, method]) => {
                if(key === 'argentina_manual') return;

                switch (method.type) {
                    case 'bank':
                        return this.bankConfig.length
                    default:
                        return this.pspList.some(psp => psp.name === key)
                }
            }).map(([key, method]) => {
                if (Array.isArray(method)) {
                    return method.map(item => ({
                        key,
                        alias: pspAliasMap[key],
                        ...item
                    }))
                }

                return {
                    key,
                    alias: pspAliasMap[key],
                    ...method
                }
                }).flat()
                

            let dikeshieldSchedule = {};

            try{
                dikeshieldSchedule = JSON.parse(this.variables['DIKESHIELD_SCHEDULE']);
            }catch{() => {}}
            
            // for dikeshield
            if(Object.keys(dikeshieldSchedule).length && (+dikeshieldSchedule.from || +dikeshieldSchedule.to) && (+dikeshieldSchedule.from != +dikeshieldSchedule.to)){
                const from = +dikeshieldSchedule.from;
                const to = +dikeshieldSchedule.to;
                const now = new Date();

                // local GMT
                const gmtOffset = -now.getTimezoneOffset() / 60;

                // local hours
                const localHoursByUTC = (now.getUTCHours() + gmtOffset + 24) % 24;
                
                let inRange;
                if (from <= to) {
                    inRange = (localHoursByUTC) >= from && (localHoursByUTC) < to;
                } else {
                    inRange = (localHoursByUTC) >= from || (localHoursByUTC) < to;
                }

                if (!inRange) {
                    filteredMethods = filteredMethods.filter(item => item.key !== 'dikeshield');
                }
            }

            // for transfer details custom psps 
            let transferDetailsPsps = this.pspList.filter(item => item.provider === 'custom').map(item => {
                return {
                    key: item.name,
                    name: String(item.name).replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase()),
                    type: 'custom',
                    alias: String(item.alias).replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase()),
                    info: item.info,
                    currencies: ['USD']
                }
            });

            return [...filteredMethods, ...transferDetailsPsps].sort((a, b) => {
                if (a.order === -1) return 1
                if (b.order === -1) return -1
                return a.order - b.order
            })
        },
        active: {
            get() {
                return this.selectedMethod || (this.getMethods.length ? this.getMethods[0] : '')
            },
            set(value) {
                this.selectedMethod = value
            }
        },
        currenciesList: {
            get() {
            if (this.active.key === 'cc-ext') {
                let firstCurrency = this.brand === 'royalwealthltd' ? 'CAD' : 'USD';
                let findFirstCurrencyIdx = this.currencies.findIndex(item => item === firstCurrency);

                if(findFirstCurrencyIdx > -1){
                    return [firstCurrency, ...this.currencies.filter(item => item !== firstCurrency)];
                }
                
                return this.currencies
            }
            return this.selectedCurrencies ? this.selectedCurrencies : this.getMethods[0]?.currencies || []
            },
            set(value) {
            this.selectedCurrencies = value
            }
        },
        currency:{
            get(){
                return this.selectedCurrency || this.active.currencies[0]
            },
            set(value){
                this.selectedCurrency = value
            }
        },
        ...mapGetters(['pspList', 'bankConfig', 'user', 'activeAccount', 'deposits', 'variables', 'conversions', 'tokens','currencies'])
    }
}
</script>


<style scoped>
.title {
    color: var(--System-OnSurface);
    font-weight: 500;
}

.methods {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 12px;
}

.icon {
    font-size: 18px;
}

.custom-icon path{
    fill: revert-layer !important;
}
</style>
